import { render, staticRenderFns } from "./PhoneFolderView.vue?vue&type=template&id=030622aa&scoped=true"
import script from "./PhoneFolderView.vue?vue&type=script&lang=js"
export * from "./PhoneFolderView.vue?vue&type=script&lang=js"
import style0 from "./PhoneFolderView.vue?vue&type=style&index=0&id=030622aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030622aa",
  null
  
)

export default component.exports